export default __webpack_public_path__ + "static/media/FalseCross.157093d1.svg";